export default __webpack_public_path__ + "static/media/Register.945b55d8.webp";